import React, { useState, useEffect } from 'react'
import '../../_css/Static.css'
import { getCMS } from '../../requests';
import { formatDateLong } from '../helper/formatters';
import { useDispatch } from 'react-redux';
import { startLoader, stopLoader } from '../../_store/reducers/loaderReducer';


const Privacy = () => {
    const dispatch = useDispatch();
  
  const [data, setData] = useState([]);
  const [updatedAt, setUpdatedAt] = useState("");

  const getTerms = async () => {
    dispatch(startLoader());
   try {
     const response = await getCMS({slug: "Privacy Policy", status: 1});
    //  console.log(response.data.content);
     setData(response.data.content);
     setUpdatedAt(response.data.updated_at);
   } catch (error) {
      console.log(error);
    
   } finally {
    dispatch(stopLoader());
   }
  }

  useEffect(() => {
    getTerms();
  }, []);





  return (
    <div className="static-term-container">
      <div className="static-term-published">Published {formatDateLong(updatedAt)}</div>

      <div className="static-term-content">
        {data.map((e) => (
          <div key={e.title} className="static-term-list">
            <div className="static-term-heading">{e.title}</div>
            <div className="static-term-text">
              {e.desc}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Privacy